import { render, staticRenderFns } from "./FormSalePayment.vue?vue&type=template&id=b746dacc"
import script from "./FormSalePayment.vue?vue&type=script&lang=js"
export * from "./FormSalePayment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports